"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  const desktopTextColor =
    pathname === "/" ? "text-[#D76A27]" : "text-[#D76A27]";

  const hamburgerColor = pathname === "/" ? "text-white" : "text-orange-500";

  return (
    <>
      <nav
        className={`absolute mt-8 hidden z-50 lg:flex w-[80%] left-1/2 transform -translate-x-1/2 justify-around text-center ${desktopTextColor}`}
      >
        {pathname == "/" && (
          <div className='absolute w-[50%] h-17.5 -top-5 mx-auto -z-10 rounded-xl  opacity-50'></div>
        )}

        <Link href='/'>
          <Image
            src='/assets/logo.webp'
            loading='eager'
            alt='Logo'
            width={130}
            height={108}
          />
        </Link>
        <div className='flex items-center justify-center h-12 gap-3 px-6 rounded-xl xl:px-10 bg-white/50 backdrop-blur-lg xl:gap-5'>
          <Link
            href='/'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/" ? "text-[#003B52]" : ""
            }`}
          >
            Domov
          </Link>
          |
          <Link
            href='/vylety'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/vylety" ? "text-[#003B52]" : ""
            }`}
          >
            Výlety
          </Link>
          |
          <Link
            href='/spomienky'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/spomienky" ? "text-[#003B52]" : ""
            }`}
          >
            Spomienky
          </Link>
          |
          <Link
            href='/o-nas'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/o-nas" ? "text-[#003B52]" : ""
            }`}
          >
            O nás
          </Link>
          |
          <Link
            href='/poukazka'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/poukazka" ? "text-[#003B52]" : ""
            }`}
          >
            Poukážky
          </Link>
          |
          <Link
            href='/vylet-na-mieru'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/vylet-na-mieru" ? "text-[#003B52]" : ""
            }`}
          >
            Výlet na mieru
          </Link>
          |
          <Link
            href='/faq'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/faq" ? "text-[#003B52]" : ""
            }`}
          >
            FAQ
          </Link>
          |
          <Link
            href='/kontakt'
            className={`font-bold hover:text-[#003B52] text-sm ${
              pathname === "/kontakt" ? "text-[#003B52]" : ""
            }`}
          >
            Kontakt
          </Link>
        </div>
        <div className='flex items-start gap-4'>
          <a
            href='https://www.instagram.com/travel_alvaro/ '
            target='_blank'
            rel='noopener noreferrer'
          >
            <Image
              src='/assets/instagram-white.svg'
              alt='Instagram Logo'
              width={45}
              height={45}
              className='bg-[#D76A27] border-2 border-[#D76A27] rounded-full'
            />
          </a>
          <a
            href='https://www.facebook.com/profile.php?id=61572937145115'
            target='_blank'
            rel='noopener noreferrer'
          >
            <Image
              src='/assets/facebook-white.svg'
              alt='Facebook Logo'
              width={45}
              height={45}
              className='bg-[#D76A27] border-2 border-[#D76A27] rounded-full'
            />
          </a>
        </div>
      </nav>

      <nav className='absolute z-50 flex items-center justify-between w-full px-4 lg:hidden'>
        <div className='max-w-20'>
          <Link href='/'>
            <Image
              src='/assets/logo.webp'
              alt='Logo'
              width={130}
              loading='eager'
              height={108}
              className='mt-6'
            />
          </Link>
        </div>
        <button onClick={() => setMenuOpen(true)} aria-label='Menu button'>
          <svg
            className={`w-8 h-8 -mt-5 mr-2 ${hamburgerColor}`}
            fill='#D76A27'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M4 6h16M4 12h16M4 18h16'
            />
          </svg>
        </button>
      </nav>

      <div
        className={`fixed inset-0 z-100 ${
          menuOpen ? "" : "pointer-events-none"
        }`}
      >
        <div
          className={`absolute inset-0 bg-white/30 backdrop-blur-sm transition-opacity duration-300 ${
            menuOpen ? "opacity-100" : "opacity-0"
          }`}
          onClick={() => setMenuOpen(false)}
        />

        <div
          className={`absolute top-0 right-0 h-full w-2/4 bg-white/30 backdrop-blur-lg text-black transform transition-transform duration-300 ${
            menuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className='flex flex-col h-full p-4'>
            <button
              onClick={() => setMenuOpen(false)}
              className='mb-4'
              aria-label='Close button'
            >
              <svg
                className='w-8 h-8'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>
            </button>

            <Image
              src='/assets/logo.webp'
              alt='Logo'
              width={130}
              loading='eager'
              height={108}
            />

            <div className='flex flex-col gap-4 mt-6 ml-8'>
              {[
                { href: "/", label: "Domov" },
                { href: "/vylety", label: "Výlety" },
                { href: "/spomienky", label: "Spomienky" },
                { href: "/o-nas", label: "O nás" },
                { href: "/poukazka", label: "Poukážky" },
                { href: "/vylet-na-mieru", label: "Výlet na mieru" },
                { href: "/faq", label: "FAQ" },
                { href: "/kontakt", label: "Kontakt" },
              ].map(({ href, label }) => (
                <Link
                  key={href}
                  href={href}
                  onClick={() => setMenuOpen(false)}
                  className='font-bold hover:text-[#003B52]'
                >
                  {label}
                </Link>
              ))}
            </div>

            <div className='flex gap-4 mt-6 ml-8 invert'>
              <a
                href='https://www.instagram.com/travel_alvaro/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Image
                  src='/assets/instagram-white.svg'
                  alt='Instagram Logo'
                  width={45}
                  height={45}
                />
              </a>
              <a
                href='https://www.facebook.com/profile.php?id=61572937145115'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Image
                  src='/assets/facebook-white.svg'
                  alt='Facebook Logo'
                  width={45}
                  height={45}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
